import { IAnalyticsEvent, IAnalyticsInfoUser } from 'affiny-core/analytics';
import { config, EAppEnv } from 'affiny-core/env';
import { EEnvCountry } from 'affiny-core/env.types';
import {
  EGTM_CUSTOM_EVENTS,
  IGtmEventParameters,
  IGtmPageViewParameters,
} from './GoogleTagManagerService.types';

const getDataLayer = () => {
  if (window.dataLayer) return window.dataLayer;

  if (config.env.envName === EAppEnv.prod) {
    console.error('dataLayer not found in global. Is GTM correctly setup ?');
  }

  window.dataLayer = [];

  return window.dataLayer;
};

interface IPageViewPushEventParams {
  event?: EGTM_CUSTOM_EVENTS.PAGE_VIEW;
  options: IGtmPageViewParameters;
}
interface IEventPushEventParams {
  event?: EGTM_CUSTOM_EVENTS.EVENT;
  options: IGtmEventParameters;
}
interface IUserInfosEventParams {
  event?: string;
  options: IAnalyticsInfoUser;
}

function pushEvent({
  event,
  options,
}: IPageViewPushEventParams | IEventPushEventParams | IUserInfosEventParams) {
  const data = { event, ...options };

  for (const key in data) {
    if (data[key] === undefined) {
      delete data[key];
    }
  }
  getDataLayer().push(data);
}

export const GoogleTagManagerService = {
  injectTag(gtmContainerId: string) {
    const scriptTag = document.createElement('script');

    // Script pasted from Google Tag Manager
    scriptTag.innerHTML = `(function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${gtmContainerId}');`;
    document.head.insertBefore(scriptTag, document.head.childNodes[0]);
  },
  trackVirtualPageView(url: string) {
    pushEvent({
      event: EGTM_CUSTOM_EVENTS.PAGE_VIEW,
      options: {
        vpvName: url,
        site_country: config.configStrategy.getCountry() as EEnvCountry,
        site_language: config.configStrategy.getLocale(),
        brand_name:
          config.configStrategy.getBrand && config.configStrategy.getBrand(),
      },
    });
  },
  trackEvent(options: IAnalyticsEvent) {
    pushEvent({ event: EGTM_CUSTOM_EVENTS.EVENT, options });
  },
  pushUserInfos(userInfos: IAnalyticsInfoUser) {
    pushEvent({ options: userInfos });
  },
};
